import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Collapse,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allFeedbackList } from "../../service/api/user/allFeedbackList";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { getFeedbackById } from "../../service/api/user/getFeedbackById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtFeedbackList, txtFullName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import InternationalPhoneFormatFun from "../../ui/InternationalPhoneFormatFun";
import { apiGetRegisteredCompanies } from "../../service/api/companies/getRegisteredCompanies";
import deleteCompanyApi from "../../service/api/companies/deleteCompany";
import CompanyDetails from "./companyDetails";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
const CompaniesListForAdmin = () => {
  const [basicModal, setBasicModal] = useState(false);
  const [initiColor, setInitiColor] = useState(true);
  const [sortingCol, setSortingCol] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [elements, setElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const [sortByValue, setSortByValue] = useState("DESC");
  const [columnName, setColumnName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [flag, setFlag] = useState(false);
  const [dataToModal, setDataToModal] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [firstCheck, setFirstCheck] = useState(false);
  const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
  const [companyData, setCompanyData] = useState(0)
  const rows = elements;

  const [filtreBox, setFiltreBox] = useState(false);
  const [filtreValue, SetFiltreValue] = useState(1);

  const { permissionArr } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || []

  const [isExpandedCompanyId, setIsExpandedCompanyId] = useState('');


  const [deleteCompanyLoading, setDeleteCompanyLoading] = useState(false);
  function deleteCompany() {
    setDeleteCompanyLoading(true)
    let details = {
      company_id_ids: dataToModal.company_id_ids,
    };
    dispatch(
      deleteCompanyApi(
        details,
        (res) => {
          setDeleteCompanyLoading(false)
          setOpenDialog(false);
          setBasicModal(false);

          let indexToDelete = elements.findIndex(item => item.company_id_ids === dataToModal.company_id_ids);
          elements.splice(indexToDelete, 1);

          setResMessage(res.data.message);

          setToasterType("success");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);


          onLoadData();
        },
        (res) => {
          setDeleteCompanyLoading(false)
          setOpenDialog(false);
          setResMessage(res.data.message);

          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  const getCallHistoryDetails = (res) => {

    // const newElements = [...elements, ...res.data];
    // const uniqueElements = Array.from(
    //   new Set(newElements.map(JSON.stringify))
    // ).map(JSON.parse);


    setElements(res.data);
    setTotalNoRecord(res.total_count);

    if (res.total_count % pageSize === 0) {
      setTotalPage(parseInt(res.total_count / pageSize));
    } else {
      setTotalPage(parseInt(res.total_count / pageSize + 1));
    }

    if (res.total_count === 0) {
      setTimeout(() => {
        setSkeltonVal(true);
      }, "3000");
    } else {
      setSkeltonVal(true);
    }

    // console.log(parseInt(res.total_records / pageSize), 'quoitent')
  };

  function onLoadData() {
    setSkeltonVal(true);
    setCustomeSkeletonLoading(true);
    const getComapnies = new FormData();
    getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
    getComapnies.append("pagination_flag", 1);
    getComapnies.append("page_index", page);
    getComapnies.append("page_size", pageSize);
    getComapnies.append("sorting_order", sortByValue);
    getComapnies.append("sorting_column_name", columnName);
    getComapnies.append("search_area", searchValue);
    dispatch(
      apiGetRegisteredCompanies(getComapnies, (res) => {
        // setElements(res.data.data);
        getCallHistoryDetails(res.data);
        setCustomeSkeletonLoading(false);
        // setTotalNoRecord(res.data.total_count);
        // if (res.data.total_count % pageSize === 0) {
        //   setTotalPage(parseInt(res.data.total_count / pageSize));
        // } else {
        //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        // }

        if (res.data.data.length === 0) {
          setTimeout(() => {
            setSkeltonVal(true);
          }, "3000");
        } else {
          setSkeltonVal(true);
        }
      }, (err) => {
        setCustomeSkeletonLoading(true);
      })
    );
  }

  const handleClose = () => {
    setCompanyModal(false)

    setPage(1);
    const ele = [];
    setElements(ele);

    onLoadData();
  }

  const handleColumnName = (name) => {
    setSortingCol(false);
    setColumnName(name);

    if (sortByValue === "ASC") {
      setSortByValue("DESC");
    }
    if (sortByValue === "DESC") {
      setSortByValue("ASC");
    }
  };

  const handleOrderValue = (order) => {
    setSortByValue(order);
  };

  const handleSearch = (e) => {
    setPage(1);
    const ele = []
    setElements(ele);

    if (searchValue.trim().length >= 2) {
      onChangePage(1)
      setColumnName('')
    }
    setSearchValue(e.target.value);
  };

  const handleChangeRowsPerPage = (e) => {
    // console.log(e)
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const onChangePage = (e, p) => {
    // setPage(p);
    setPage(e);
  };



  useEffect(() => {
    onLoadData();
  }, [sortByValue, pageSize, page, columnName, filtreValue]);

  function onLoadSearch() {
    setSkeltonVal(true);
    const getComapnies = new FormData();
    getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
    getComapnies.append("pagination_flag", 1);
    getComapnies.append("page_index", 1);
    getComapnies.append("page_size", pageSize);
    getComapnies.append("sorting_order", sortByValue);
    getComapnies.append("sorting_column_name", "");
    getComapnies.append("search_area", searchValue);

    dispatch(
      apiGetRegisteredCompanies(getComapnies, (res) => {
        getCallHistoryDetails(res.data);
        // setElements(res.data.data);
        // setTotalNoRecord(res.data.total_count);
        // if (res.data.total_count % pageSize === 0) {
        //   setTotalPage(parseInt(res.data.total_count / pageSize));
        // } else {
        //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        // }

        if (res.data.data.length === 0) {
          setTimeout(() => {
            setSkeltonVal(true);
          }, "3000");
        } else {
          setSkeltonVal(true);
        }
      })
    );
  }
  useEffect(() => {
    // if (searchValue.trim().length > 2) {

    //   const ele = [];
    //   setPage(1);
    //   setElements(ele);

    //   setFlag(true);
    //   const timeOutId = setTimeout(onLoadSearch, 1000);
    //   return () => clearTimeout(timeOutId);
    // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
    //   if (flag) {
    //     onLoadData();
    //   }
    // }

    if (searchValue.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0) {
      if (flag) {
        onLoadSearch();
      }
    }
  }, [searchValue]);

  const percentage = 70;

  const tooltipDelete = (
    <Tooltip id="tooltip">
      <strong>Delete</strong>
    </Tooltip>
  );
  const tooltipView = (
    <Tooltip id="tooltip">
      <strong>View</strong>
    </Tooltip>
  );
  const tooltipEdit = (
    <Tooltip id="tooltip">
      <strong>Edit</strong>
    </Tooltip>
  );
  // Modal triggers for the Feedback details
  const [showFeedbackDetails, setShowFeedbackDetails] = useState(false);

  const handleCloseFeedbackDetails = () => {

    setShowFeedbackDetails(false)
  };
  const handleShowAddFeedbackDetails = (e) => {
    e.stopPropagation();
    setShowFeedbackDetails(true);
  };

  const [callDetailsObj, setCallDetailsObj] = useState({});
  const [time, setTime] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState(0);
  const [companyModal, setCompanyModal] = useState(false)
  const [companyModalType, setCompanyModalType] = useState("")

  const backToAdminDashboard = () => {
    window.history.back()
  }

  function handleOpenFiltreBox() {
    setFiltreBox(!filtreBox);
  }

  function handleSetFiltreValue(v) {
    SetFiltreValue(v);
    const ele = [];
    setPage(1);
    setElements(ele);
    if (v === 1) {
      setSortByValue("DESC");
    } else if (v === 2) {
      setSortByValue("ASC");
    }
  }

  const searchAreaVal = (e) => {
    // setSearchArea(e.target.value)
    // if (searchArea.trim().length >= 2) {
    //     onChangePage(1)
    // }

    setSearchValue(e.target.value)
    if (searchValue.trim().length >= 2) {
      onChangePage(1)
    }
  }

  // Format the unix time in given format
  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? 'am' : 'pm';
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  return (
    <div>
      {/* New Admin dashboard for registered companies */}
      <div className="row mx-3 mb-5" style={{}}>
        <div className="col-12 px-0">

          <div className="row mx-0 p-3">
            <div className="col-6 px-0 ps-2 d-flex align-item-center justify-content-start">
              <span className="fs-4 fw-bold text-black">{"Registered companies"}</span>
            </div>

            <div className="col-6 px-0 pe-2 d-flex align-item-center justify-content-end">
              {(permissionArray.includes("CREATE USER")) &&
                <button
                  onClick={(e) => {
                    setCompanyModal(true)
                    setCompanyModalType("add")
                  }}
                  className="admin-add-user "
                  style={{ width: 'auto' }}
                  variant="light btn-rounded">

                  <i
                    className="bi bi-plus-circle-fill"
                    style={{ marginRight: "10px" }}></i>
                  {`Add company`}
                </button>
              }
            </div>
          </div>

          <div className='my-3'>
            <PaginationAndSearching
              handleSearch={searchAreaVal}
              // searchValue={searchArea}
              searchValue={searchValue}
              defaultValue={pageSize}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalPage}
              onChange={onChangePage}
            />
          </div>

          <Table responsive >

            <thead>
              <tr className='text-black bg-light'>
                <th
                  style={{ fontWeight: '700' }}
                >
                  {`Actions`}
                </th>
                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("company_name_chr") }}
                >
                  {`Company Name`}
                  <span className="ml-1">
                    {columnName === 'company_name_chr' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>
                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("ein_chr") }}
                >
                  {`EIN`}
                  <span className="ml-1">
                    {columnName === 'ein_chr' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("company_email_chr") }}
                >
                  {`Email`}
                  <span className="ml-1">
                    {columnName === 'company_email_chr' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("company_phone_number_int") }}
                >
                  {`Phone`}
                  <span className="ml-1">
                    {columnName === 'company_phone_number_int' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>


                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("created_date_dtm") }}
                >
                  {`Created on`}
                  <span className="ml-1">
                    {columnName === 'created_date_dtm' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th></th>
              </tr>
            </thead>

            <tbody>
              {customeSkeletonLoading ?
                <SkeletonTableRow cols={7} /> :
                <>
                  {elements?.length > 0 ?
                    <>
                      {elements?.map((element, index) => {
                        return (
                          <>
                            <tr
                              className={`notification-rows font-w700 ${isExpandedCompanyId === element.company_id_ids ? "bg-primary text-white " : ""}`}
                              key={index}
                              onClick={() => {
                                // onRowClick(element)
                                if (element?.company_id_ids === isExpandedCompanyId) {
                                  setIsExpandedCompanyId('')
                                } else {
                                  setIsExpandedCompanyId(element.company_id_ids)
                                }
                              }}
                            >
                              <td className="d-flex align-items-center">
                                <div className="me-1">
                                  <div className="tooltipCustom">
                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                    <span
                                      className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                      style={{ height: '35px', width: '35px' }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setCompanyModal(true)
                                        setCompanyModalType("edit")
                                        setCompanyData(element.company_id_ids)
                                      }}
                                    >
                                      <i className="bi bi-pencil-square"></i>
                                    </span>
                                  </div>
                                </div>

                                <div className="tooltipCustom">
                                  <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                  <span
                                    className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.company_id_ids === isExpandedCompanyId ? '' : 'text-danger'} `}
                                    style={{ height: '35px', width: '35px' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDataToModal(element);
                                      setBasicModal(true);
                                    }}
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </span>
                                </div>
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  {element?.company_logo_url ? <img
                                    src={element?.company_logo_url}
                                    className={`rounded-lg me-2 ${element?.company_id_ids === isExpandedCompanyId ? "border" : ""} rounded-3`}
                                    width="24"
                                    height="24"
                                    alt=""
                                    style={{ objectFit: "contain" }}
                                  /> :
                                    <i style={{ height: "24px", width: "24px" }} className="bi bi-person-circle fs-4 me-2"></i>
                                  }

                                  {" "}
                                  <span className="w-space-no">{`${element.company_name_chr ? element.company_name_chr : "-"}`}</span>
                                </div>
                              </td>

                              <td>
                                <span
                                  className="w-space-no">
                                  {`${element?.ein_chr ? element?.ein_chr : "-"}`}
                                </span>
                              </td>


                              <td>
                                <span className="w-space-no">{element.company_email_chr ? element.company_email_chr : "-"}</span>
                              </td>

                              <td>

                                <span>{!element.company_phone_number_int ? ('-') : <InternationalPhoneFormat countryCode={element.company_phone_code_id_lng} phoneNumber={`${element.company_phone_number_int}`} />}</span>

                              </td>

                              <td>
                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                <span className="">{`${element?.created_date_dtm ?
                                  new Intl.DateTimeFormat("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    hour12: true
                                  }).format(
                                    element?.created_date_dtm * 1000
                                  ) : '-'}`}</span>
                              </td>


                              <td>
                                {/* <OverlayTrigger placement="top" overlay={tooltip}> */}
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (element?.company_id_ids === isExpandedCompanyId) {
                                      setIsExpandedCompanyId('')
                                    } else {
                                      setIsExpandedCompanyId(element.company_id_ids)
                                    }
                                  }}
                                  className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                  style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                  {element?.company_id_ids === isExpandedCompanyId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                </div>
                                {/* </OverlayTrigger> */}
                              </td>
                            </tr>

                            <tr>
                              <td colSpan="8" className={`bg-light ${(element?.company_id_ids !== isExpandedCompanyId) ? 'p-0' : ''}`}>
                                <Collapse
                                  in={element?.company_id_ids === isExpandedCompanyId}
                                >
                                  <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`EIN`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element.ein_chr ? element.ein_chr : "-"}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Company name`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element.company_name_chr ? element.company_name_chr : "-"}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Company address`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{element.company_address_chr ? element.company_address_chr : "-"}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Email`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{element.company_email_chr ? element.company_email_chr : "-"}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Phone`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{!element.company_phone_number_int ? ('-') : <InternationalPhoneFormat countryCode={element.company_phone_code_id_lng} phoneNumber={`${element.company_phone_number_int}`} />}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}
                                          {/* <span className="">
                                            {new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "long",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                            }).format(element.created_date_dtm + "000")}
                                          </span> */}

                                          <span className="">{`${element?.created_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.created_date_dtm * 1000
                                            ) : '-'}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Updated on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}
                                          {/* <span className="">
                                            {new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "long",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                            }).format(element.updated_date_dtm + "000")}
                                          </span> */}

                                          <span className="">{`${element?.updated_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.updated_date_dtm * 1000
                                            ) : '-'}`}</span>
                                        </div>
                                      </div>


                                      {/* <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Status`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className=" font-w600" style={{ color: element?.is_company_verified_ysn ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{element?.is_company_verified_ysn ? `Verified` : `Unverified`}</span>
                                        </div>
                                      </div> */}

                                    </div>
                                  </div>
                                </Collapse>
                              </td>
                            </tr>
                          </>
                        )
                      })}</> :
                    <tr>
                      <td colSpan="7">No Records Found</td>
                    </tr>
                  }
                </>
              }
            </tbody>
          </Table>


          {false && <>
            {/* Searching and sorting */}
            <div
              className="border border-bottom border-dark border-end-0 border-start-0 border-top mx-0 row"
              style={{
                // borderTop: "1px solid gray",
                // borderBottom: "1px solid gray",
              }}>
              <div
                className="row mx-0 my-3 align-items-center"
                style={{ minHeight: "40px" }}>

                <div className="col-12">
                  <div className="row">
                    <span className="fs-6 p-2 d-flex align-items-center justify-content-end">
                      <span className="fs-5 p-2 d-flex align-items-center">
                        <LuArrowUpDown
                          className="pointer"
                          style={{ marginRight: "4px", color: "black" }}
                          onClick={handleOpenFiltreBox}
                        />
                        <span
                          className="fs-6  pointer"
                          style={{ position: "relative" }}
                          onClick={handleOpenFiltreBox}
                        >
                          {filtreValue == 1 && "Date: Newset first"}
                          {filtreValue == 2 && "Date: Oldest first"}
                          &nbsp;
                          {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                          <span
                            className={`${filtreBox ? "" : "d-none"} p-3`}
                            style={{
                              position: "absolute",
                              top: "26px",
                              width: "152px",

                              border: "1px solid lightgray",
                              background: "white",
                              right: "0",
                              boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                            }}>
                            <div className="row">
                              <div
                                className={`${filtreValue == 1 ? "dt" : ""
                                  } d-flex justify-content-start m-1 pointer `}
                                onClick={() => {
                                  handleSetFiltreValue(1);
                                }}>
                                Date: Newest first
                              </div>
                              <div
                                className={`${filtreValue == 2 ? "dt" : ""
                                  } d-flex justify-content-start m-1 pointer`}
                                onClick={() => {
                                  handleSetFiltreValue(2);
                                }}>
                                Date: Oldest first
                              </div>

                            </div>
                          </span>
                        </span>
                      </span>

                      <span
                        className="fs-6 p-2 d-flex align-items-center"
                        style={{
                          border: "1px solid lightgray",
                          borderRadius: "4px",
                        }}>
                        <FaSearch style={{ marginRight: "4px", color: "black" }} />
                        <input
                          placeholder="Search"
                          style={{ border: "0px", width: "100%" }}
                          onChange={handleSearch}
                          value={searchValue}
                        />
                      </span>

                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Users listing */}

            <div className="overflow-auto">
              {elements.length > 0 ?
                <>
                  {elements.map((element, index) => {
                    return (
                      <div
                        key={index}
                        className="row mx-0 my-2 cursor-pointer overlay-action-btn "
                        onClick={(e) => {
                          // setCompanyModal(true)
                          // setCompanyModalType("view")
                          // setCompanyData(element.company_id_ids)
                          // handleShowParticularUserDetails(e);
                          setCompanyModal(true)
                          setCompanyModalType("edit")
                          setCompanyData(element.company_id_ids)
                        }}
                      >
                        <div className="col-12 px-0 py-2 border-bottom border-light" style={{}}>
                          <div className="d-flex">
                            <div className="d-flex justify-content-center p-2">
                              <span className="bg-light rounded-circle border border-dark border-2 d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                                {element?.company_logo_url ?
                                  <img className="rounded-circle w-100 h-100" src={element?.company_logo_url} style={{ objectFit: 'cover' }} alt="" />
                                  :
                                  <i className="bi bi-person-circle fs-1"></i>
                                }
                              </span>
                            </div>

                            <div className="d-flex flex-column w-100 px-3 py-2">

                              {/* <div className="row mx-0 mb-1">
                              <div className="col-12 font-w600 text-black d-flex justify-content-end align-items-center">
                                <span className="bg-light px-3 py-1 rounded-pill">
                                  {element?.role_display_name_chr}
                                </span>
                              </div>
                            </div> */}

                              <div className="row mx-0 fs-7 mb-1">
                                <div className="col-4 fw-bold text-black">
                                  <span>{"Company name"}</span>
                                </div>
                                <div className="col-8 font-w500">
                                  <span>{element.company_name_chr == "" ||
                                    element.company_name_chr == null
                                    ? "-"
                                    : element.company_name_chr}</span>
                                </div>
                              </div>

                              {/* <div className="row mx-0 fs-6 mb-1">
                            <div className="col-4 fw-bold text-black">
                              <span>{"Role"}</span>
                            </div>
                            <div className="col-8 font-w500">
                              <span>{element.role_name_chr}</span>
                            </div>
                          </div> */}

                              <div className="row mx-0 fs-7 mb-1">
                                <div className="col-4 fw-bold text-black">
                                  <span>{"Company email"}</span>
                                </div>
                                <div className="col-8 font-w500">
                                  <span>{element.company_email_chr == "" || element.company_email_chr == null
                                    ? "-"
                                    : element.company_email_chr}</span>
                                </div>
                              </div>

                              {/* <div className="row mx-0 fs-6 mb-1">
                              <div className="col-4 fw-bold text-black">
                                <span>{"Phone number"}</span>
                              </div>
                              <div className="col-8 font-w500">
                                <span>{element.phone_number_int == null ? ('NA') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                              </div>
                            </div> */}

                              <div className="row mx-0 fs-7 mb-1">
                                <div className="col-4 fw-bold text-black">
                                  <span>{"Created date"}</span>
                                </div>
                                <div className="col-8 font-w500">
                                  <span>
                                    {new Intl.DateTimeFormat("en-US", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                      hour: "numeric",
                                      minute: "numeric",
                                    }).format(element.created_date_dtm + "000")}
                                  </span>
                                </div>
                              </div>

                              {/* <div className="row mx-0 fs-6 mb-1">
                            <div className="col-4 fw-bold text-black">
                              <span>{"Last login"}</span>
                            </div>
                            <div className="col-8 font-w500">
                              <span>
                                {element.last_log_in_dtm != null
                                  ? new Intl.DateTimeFormat("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  }).format(element.last_log_in_dtm + "000")
                                  : "NA"}
                              </span>
                            </div>
                          </div> */}



                              <div className="row mx-0">
                                <div className="col-12 d-flex align-items-center justify-content-end">

                                  {/* <button
                                  className="me-2 admin-btn-group border-0"
                                  style={{ width: 'auto', borderRadius: '4px' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCompanyModal(true)
                                    setCompanyModalType("view")
                                    setCompanyData(element.company_id_ids)
                                  }}
                                >
                                  <i className="bi bi-eye me-2 text-success" />
                                  {"View"}
                                </button> */}


                                  <button
                                    className="me-2 admin-btn-group border-0"
                                    style={{ width: 'auto', borderRadius: '4px' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setCompanyModal(true)
                                      setCompanyModalType("edit")
                                      setCompanyData(element.company_id_ids)
                                    }}
                                  >
                                    <i className="bi bi-pencil-square me-2 text-success" />
                                    {"Update"}
                                  </button>

                                  <button
                                    className="admin-btn-group border-0"
                                    style={{ width: 'auto', borderRadius: '4px' }}
                                    onClick={(e) => {
                                      setDataToModal(element);
                                      e.stopPropagation();
                                      setBasicModal(true);
                                    }}
                                  >
                                    <i className="bi bi-trash me-2 text-danger" />
                                    {"Delete"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}

                  {customeSkeletonLoading
                    ? ((elements)
                    )?.length > 0 &&
                    totalNoRecord >
                    (
                      (elements)
                    )?.length && (
                      <div className="text-center pointer my-2">Loading ...</div>
                    )
                    : (
                      (elements)
                    )?.length > 0 &&
                    totalNoRecord >
                    (
                      (elements)
                    )?.length && (
                      <div
                        className="text-center pointer my-2"
                        onClick={() => {
                          setPage(page + 1);
                        }}>
                        click to view more
                      </div>
                    )}
                </> :
                <>
                  <div className="row mx-0 mt-5">
                    <div className="col-12 px-0 text-center">
                      <span className="fs-6 font-w500">{"No records found"}</span>
                    </div>
                  </div>
                </>
              }
            </div>
          </>}

        </div>
      </div>

      <AcceptRejectModal
        text={"Are you sure you want to delete this Company?"}
        onClickReject={() => {
          setBasicModal(false);
        }}
        onClickAccept={deleteCompany}
        modalStatus={basicModal}
        loaderActive={deleteCompanyLoading}
        loadingButtonName={"Deleting..."}
      />
      {companyModal && <CompanyDetails companyModalStatus={companyModal} handleClose={() => { handleClose() }} modalType={companyModalType} companyID={companyData} />}

      {handleToaster && <ResponceToaster toasterType={toasterType} message={resMessage} />}
    </div>
  );
};

export default CompaniesListForAdmin;
